import { makeAutoObservable, action, observable } from 'mobx';

// 의뢰자 정보 — 롯데홈쇼핑 접수 1단계와 같은 항목. 접수 시 인성 접수자(c_name·c_dept_name·c_charge_name·c_mobile)로 간다
const emptyRequester = () => ({
  company: '',   // 상호
  dept: '',      // 부서명
  name: '',      // 담당자명
  tel: '',       // 연락처
  addr: '',      // 주소
  addrDtl: '',   // 상세주소
  bcode: '',     // 주소 법정동코드
});

export default class CommonStore {
  root;
  qsStore;
  headerTitle = '';
  toAddress = '';
  toBcode = '';
  fromAddress = '';
  fromBcode = '';
  // 출발지·도착지 — 의뢰자와 같은 항목(상호·부서명·담당자명·연락처) + 상세주소
  etcAddress = {
    startAddrDtl: '',
    startCompany: '',
    startDept: '',
    startNm: '',
    startTel: '',
    endAddrDtl: '',
    endCompany: '',
    endDept: '',
    endNm: '',
    endTel: '',
    addressName: '',
  }
  requester = emptyRequester();


  constructor(root) {
    this.root = root;
    this.qsStore = this.root.qsStore;
    makeAutoObservable(
      this, {
        headerTitle: observable,
        toAddress: observable,
        fromAddress: observable,
        etcAddress: observable,
        requester: observable,
        setMobileTitle: action,
        setDaumAddress: action,
        setEtcAddress: action,
        initialAddress: action,
        setRequester: action,
        setRequesterAddress: action,
        prefillRequester: action,
      }
    );
  }

  initialAddress = () => {
    this.toAddress = '';
    this.toBcode = '';
    this.fromAddress = '';
    this.fromBcode = '';

    // this.etcAddress = {
    //   startAddrDtl: '',
    //   startTel: '',
    //   startNm: '',
    //   endNm: '',
    //   endAddrDtl: '',
    //   endTel: '',
    // }
  }

  // mobile header title
  setMobileTitle = (title) => {
    this.headerTitle = title;
  };

  // 주소 검색 — type 'to'(출발지) | 'from'(도착지)
  setDaumAddress = (type, address, bcode) => {
    if (type === 'to') {
      this.toAddress = address;
      this.toBcode = bcode;
    } else if (type === 'from') {
      this.fromAddress = address;
      this.fromBcode = bcode;
    }
  }

  // 기타 주소 내용 각각 입력
  setEtcAddress = (name, value) => {
    const temp = this.etcAddress;

    if (name === 'each') {
      for (const [k, v] of Object.entries(value)) {
        if (k === "startAddr") this.toAddress = v;
        else if (k === "endAddr") this.fromAddress = v;
        else if (k === "startPointCode") this.toBcode = v;
        else if (k === "endPointCode") this.fromBcode = v;
        temp[k] = v ? v : "";
      }
    } else {
      if (temp.hasOwnProperty(name)) temp[name] = value ? value : "";
    }
    this.etcAddress = { ...temp };
  }

  // 의뢰자 정보 한 칸
  setRequester = (name, value) => {
    if (!Object.prototype.hasOwnProperty.call(this.requester, name)) return;
    this.requester = { ...this.requester, [name]: value ? value : '' };
  }

  // 의뢰자 주소(주소 검색 결과)
  setRequesterAddress = (address, bcode) => {
    this.requester = { ...this.requester, addr: address || '', bcode: bcode || '' };
  }

  // 로그인 회원 정보로 비어 있는 칸만 채운다 — 회원에 저장된 의뢰자 정보(가입 때 입력·마지막 접수) 우선, 없으면 상호·이름·연락처
  prefillRequester = (user) => {
    if (!user) return;
    const saved = user.requester || {};
    const source = {
      company: saved.company || user.companyName,
      dept: saved.dept,
      name: saved.name || user.name,
      tel: saved.tel || user.phone,
      addr: saved.addr,
      addrDtl: saved.addrDtl,
      bcode: saved.bcode,
    };
    const next = { ...this.requester };
    Object.keys(next).forEach((key) => {
      if (!next[key] && source[key]) next[key] = source[key];
    });
    this.requester = next;
  }
}
